// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_DETAILS_REQUEST = 'FETCH_CUTTING_DC_DETAILS_REQUEST';
export const FETCH_CUTTING_DC_DETAILS_SUCCESS = 'FETCH_CUTTING_DC_DETAILS_SUCCESS';
export const FETCH_CUTTING_DC_DETAILS_FAILURE = 'FETCH_CUTTING_DC_DETAILS_FAILURE';

export const FETCH_CUTTING_DC_DETAILS_SIZE_GRID_REQUEST = 'FETCH_CUTTING_DC_DETAILS_SIZE_GRID_REQUEST';
export const FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS = 'FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS';
export const FETCH_CUTTING_DC_DETAILS_SIZE_GRID_FAILURE = 'FETCH_CUTTING_DC_DETAILS_SIZE_GRID_FAILURE';

export const FETCH_CUTTING_DC_DETAILS_FORM_REQUEST = 'FETCH_CUTTING_DC_DETAILS_FORM_REQUEST';
export const FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS = 'FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS';
export const FETCH_CUTTING_DC_DETAILS_FORM_FAILURE = 'FETCH_CUTTING_DC_DETAILS_FORM_FAILURE';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST = 'FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST';
export const FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS = 'FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS';
export const FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE = 'FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_PROGRAM_REQUEST = 'FETCH_CUTTING_DC_PROGRAM_REQUEST';
export const FETCH_CUTTING_DC_PROGRAM_SUCCESS = 'FETCH_CUTTING_DC_PROGRAM_SUCCESS';
export const FETCH_CUTTING_DC_PROGRAM_FAILURE = 'FETCH_CUTTING_DC_PROGRAM_FAILURE';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST = 'FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST';
export const FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS = 'FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS';
export const FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE = 'FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE';

export const FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST = 'FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST';
export const FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS = 'FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS';
export const FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE = 'FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST = 'FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST';
export const FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS = 'FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS';
export const FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE = 'FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS BY ID
export const FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR CUTTING_DC DETAILS
export const CREATE_CUTTING_DC_DETAILS_REQUEST = 'CREATE_CUTTING_DC_DETAILS_REQUEST';
export const CREATE_CUTTING_DC_DETAILS_SUCCESS = 'CREATE_CUTTING_DC_DETAILS_SUCCESS';
export const CREATE_CUTTING_DC_DETAILS_FAILURE = 'CREATE_CUTTING_DC_DETAILS_FAILURE';

// CREATE PROPERTIES FOR CUTTING_DC DETAILS
export const CREATE_CUTTING_DC_DETAILS_GRID_REQUEST = 'CREATE_CUTTING_DC_DETAILS_GRID_REQUEST';
export const CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS = 'CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS';
export const CREATE_CUTTING_DC_DETAILS_GRID_FAILURE = 'CREATE_CUTTING_DC_DETAILS_GRID_FAILURE';

// CREATE PROPERTIES FOR CUTTING_DC DETAILS
export const CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST = 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST';
export const CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS = 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS';
export const CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE = 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_CUTTING_DC_DETAILS = 'CREATE_USER_FORM_CUTTING_DC_DETAILS';
export const RESET_CUTTING_DC_DETAIL_GENERATE_SKU = 'RESET_CUTTING_DC_DETAIL_GENERATE_SKU';

// UPDATE PROPERTIES FOR CUTTING_DC DETAILS
export const UPDATE_CUTTING_DC_DETAILS_REQUEST = 'UPDATE_CUTTING_DC_DETAILS_REQUEST';
export const UPDATE_CUTTING_DC_DETAILS_SUCCESS = 'UPDATE_CUTTING_DC_DETAILS_SUCCESS';
export const UPDATE_CUTTING_DC_DETAILS_FAILURE = 'UPDATE_CUTTING_DC_DETAILS_FAILURE';

// FETCH SINGLE CUTTING_DC_DETAILS
export const FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR CUTTING_DC DETAILS
export const DELETE_CUTTING_DC_DETAILS_REQUEST = 'DELETE_CUTTING_DC_DETAILS_REQUEST';
export const DELETE_CUTTING_DC_DETAILS_SUCCESS = 'DELETE_CUTTING_DC_DETAILS_SUCCESS';
export const DELETE_CUTTING_DC_DETAILS_FAILURE = 'DELETE_CUTTING_DC_DETAILS_FAILURE';

export const FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const CUTTING_DC_DETAILS_USERFORM_RESET = 'CUTTING_DC_DETAILS_USERFORM_RESET';

export const CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET = 'CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET';

export const CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET = 'CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET';
export const CREATE_USER_FORM_CUTTING_DC_EDIT_QTY = 'CREATE_USER_FORM_CUTTING_DC_EDIT_QTY';

export const CUTTING_EDITABLE_QUANTITY_VALUE_REQUEST = 'CUTTING_EDITABLE_QUANTITY_VALUE_REQUEST'
export const CUTTING_EDITABLE_QUANTITY_VALUE_SUCCESS = 'CUTTING_EDITABLE_QUANTITY_VALUE_SUCCESS'
export const CUTTING_EDITABLE_QUANTITY_VALUE_FALIURE = 'CUTTING_EDITABLE_QUANTITY_VALUE_FALIURE'

export const INITAIL_LOADED_GRID_DATA_SIZE = 'INITAIL_LOADED_GRID_DATA_SIZE'

export const CUTTING_EDITABLE_INNER_QUANTITY_VALUE_REQUEST = 'CUTTING_EDITABLE_INNER_QUANTITY_VALUE_REQUEST'
export const CUTTING_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS = 'CUTTING_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS'
export const CUTTING_EDITABLE_INNER_QUANTITY_VALUE_FALIURE = 'CUTTING_EDITABLE_INNER_QUANTITY_VALUE_FALIURE'


export const FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_REQUEST = 'FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_REQUEST';
export const FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_SUCCESS = 'FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_SUCCESS';
export const FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_FAILURE = 'FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_FAILURE';


export const CUTTING_DC_PROGRAM_ID_REQUEST = 'CUTTING_DC_PROGRAM_ID_REQUEST';
export const CUTTING_DC_PROGRAM_ID_SUCCESS = 'CUTTING_DC_PROGRAM_ID_SUCCESS';
export const CUTTING_DC_PROGRAM_ID_FALIURE = 'CUTTING_DC_PROGRAM_ID_FALIURE';


export const CUTTING_DC_DETAILS_DELETE_FABRIC_REQUEST = 'CUTTING_DC_DETAILS_DELETE_FABRIC_REQUEST';
export const CUTTING_DC_DETAILS_DELETE_FABRIC_SUCCESS = 'CUTTING_DC_DETAILS_DELETE_FABRIC_SUCCESS';
export const CUTTING_DC_DETAILS_DELETE_FABRIC_FAILURE = 'CUTTING_DC_DETAILS_DELETE_FABRIC_FAILURE';


export const CUTTING_DC_DETAILS_DELETE_REQUEST = 'CUTTING_DC_DETAILS_DELETE_REQUEST';
export const CUTTING_DC_DETAILS_DELETE_SUCCESS = 'CUTTING_DC_DETAILS_DELETE_SUCCESS';
export const CUTTING_DC_DETAILS_DELETE_FAILURE = 'CUTTING_DC_DETAILS_DELETE_FAILURE';



export const CHECK_ALL_UPDATE_REQUEST = 'CHECK_ALL_UPDATE_REQUEST';
export const CHECK_ALL_UPDATE_SUCCESS = 'CHECK_ALL_UPDATE_SUCCESS';
export const CHECK_ALL_UPDATE_FAILURE = 'CHECK_ALL_UPDATE_FAILURE';


export const RESET_USER_FORM_TO_DEFAULT = 'RESET_USER_FORM_TO_DEFAULT';

export const FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_RESET = 'FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_RESET';







